import Vue from 'vue'
import VueRouter from 'vue-router'

import Main from '../views/Main.vue'
import Detail from '../views/Detail.vue'
import EnterpriseDisplay from '../views/EnterpriseDisplay.vue';
import News from '../views/News.vue';
// import FamousEnterpriseEntry from '../views/FamousEnterpriseEntry.vue';
// import ContactUs from '../views/ContactUs.vue';

const originalPush=VueRouter.prototype.push;
VueRouter.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err=>err)
}

Vue.use(VueRouter)

//1.创建路由组件
//2.将路由与组件进行映射
//3.创建router实例

const routes = [
    // 主路由
    {
        path:'/',
        component:Main,
        meta: { hideDetail: false }, // 隐藏默认的 Detail 组件,
        children:[{
          path:'/Detail',
          name:'Detail',
          component:Detail,
         },{
          path:'/enterprise-display',
          name:'EnterpriseDisplay',
          component:EnterpriseDisplay
         },{
          path: '/news',
          name:'News',
          component:News,
          meta: {
            hideDetail: true, // 隐藏 Detail 组件
            showRouterView: true // 显示路由内容
          } 
         }]

    },
    // {
    //     path: '/news',
    //     component: News
    // },
    // {
    //     path: '/famous-enterprise-entry',
    //     component: FamousEnterpriseEntry
    // },
    // {
    //     path: '/contact-us',
    //     component: ContactUs
    // }
];
  const router = new VueRouter({
    mode:'hash',
    routes // (缩写) 相当于 routes: routes
  })
export default router